import { Dispatch } from 'react'

import { Http } from 'lib'
import { setIsReSendingEmail, EmailVerificationAction } from './store/Actions'

import { EmailVerificationState } from './store/State'
import IUserData from 'types/sign-in/IUserData'

import apiUrlAddresses from '../../config/constants/api-urls-addresses'

export default class EmailVerificationService {
  static resendEmail(
    state: EmailVerificationState,
    dispatch: Dispatch<EmailVerificationAction>,
    onSuccess: (userData: IUserData) => void,
    onError: (error: string) => void
  ) {
    return async () => {
      if (!state.isReSendingEmail) {
        dispatch(setIsReSendingEmail(true))

        const [data, , error] = await Http.get<IUserData>(apiUrlAddresses.account.emailVerification.resend())

        dispatch(setIsReSendingEmail(false))

        if (error) {
          onError(error)
          return
        }

        onSuccess(data)
      }
    }
  }
}
